import React from "react"

import { concatClassNames } from "helpers/jsxHelpers"

import { NavTabsContentProps } from "./interfaces"
import { NavTabsContentList, NavTabsList } from "./components"

import "./index.scss"

const NavTabsContent: React.FC<NavTabsContentProps> = ({ tabs, className }) => {
	const containerStyles = concatClassNames([
		"navtabs-container-body",
		className,
	])

	return (
		<div className={containerStyles}>
			<NavTabsList tabs={tabs} className={className} />
			<NavTabsContentList tabs={tabs} className={className} />
		</div>
	)
}

export default NavTabsContent
